(function () {
    /**************
     Mobile Nav
     ***************/

// find the announcement bar that's currently visible
    const announcement = Array.from(document.querySelectorAll('[id*="shopify-section-theme-announcement"]')).find(el => el.offsetHeight > 0);

    const header = document.querySelector('#headerV3');
    const slider = document.querySelector('#sliderV3');

    function updateMobileSliderPosition() {
        // calculate current scroll position
        const scrollPosition = window.scrollY;

        // calculate height of the announcement bar
        const announcementHeight = (announcement ? announcement.offsetHeight : 0) + (document.querySelector(".countdown-timer-block")?.offsetHeight ?? 0);

        // calculate height of the header
        const headerHeight = header.offsetHeight;

        // calculate total offset top
        // we need to subtract the lesser of the announcement height or the scroll position since the announcement bar is static and the header is sticky
        let totalOffsetTop = announcementHeight + headerHeight - Math.min(announcementHeight, scrollPosition);

        // header might have been dynamically created from 'header-override-v2' section, include with the offset top
        if (!announcement && document.querySelector('.announcementOverride')) {
            totalOffsetTop += document.querySelector('.announcementOverride').offsetHeight;
        }

        // set the slider top position
        slider.style.top = `${totalOffsetTop - 1}px`;

        // set the slider height
        slider.style.height = `${document.documentElement.clientHeight - totalOffsetTop}px`;
        if (document.querySelector('.sliderV3ContentIcon')) {
            document.querySelector('.sliderV3ContentIcon').style.bottom = `-${totalOffsetTop}px`;
        }
    }

// initial position
    updateMobileSliderPosition();

// throttle reposition to one run per frame, and skip the layout reads entirely
// when the menu is closed (it's recalculated on open in the menu-click handler)
    let sliderPositionTicking = false;

    function requestSliderPositionUpdate() {
        if (!slider.open || sliderPositionTicking) {
            return;
        }
        sliderPositionTicking = true;
        requestAnimationFrame(function () {
            updateMobileSliderPosition();
            sliderPositionTicking = false;
        });
    }

// change as sticky header activates
    window.addEventListener('scroll', requestSliderPositionUpdate);
    window.addEventListener('resize', requestSliderPositionUpdate);

//open menu event
    document.querySelector("#headerV3Menu")?.addEventListener("click", function () {
        updateMobileSliderPosition();
        // add active class - we'll use it for a smooth animation close
        slider.classList.add('active');
        slider.showModal();
        document.querySelector("body").classList.add("noScroll");
        header.querySelector('#headerV3Exit').classList.add("active");
    })

// toggle menu open/close
    header.querySelector('#headerV3Exit')?.addEventListener('click', function () {
        // remove the active class
        slider.classList.remove("active");

        // wait a few seconds to give animation time to play out
        setTimeout(() => {
            slider.close();
        }, 300)
    })

// close nav when clicking backdrop event listener
    slider.addEventListener("click", function (event) {
        if (event.target === this) {
            // remove the active class
            this.classList.remove("active");

            // wait a few seconds to give animation time to play out
            setTimeout(() => {
                this.close();
            }, 300)
        }
    });

// accessibility close
    document.querySelector("#sliderV3").addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
        header.querySelector('#headerV3Exit').classList.remove("active");
        // close any open sub menus
        subMenus.forEach(menu => menu.classList.remove("active"));
    });

// register dialog
    dialogPolyfill.registerDialog(slider);

    /**************
     Nested Menu Logic
     ***************/

// get all the main and sub categories
    const menuCategories = Array.from(document.querySelectorAll(".sliderV3ContentItem.subMenu"));
    const subMenus = document.querySelectorAll('.sliderV3ContentItemLinks');

    function openItemMenu(item) {
        // get the menu title
        const menuTitle = item.querySelector('.sliderV3ContentItemInfoTitle')?.innerText;
        // get the type
        const neededType = item.dataset.type;

        // if either of these pieces of info are missing, bail
        if (!neededType || !menuTitle) {
            return;
        }

        /// find the submenu we need to show
        const subMenus = document.querySelectorAll('.sliderV3ContentItemLinks');

        // show the matching links list, hide the rest
        subMenus.forEach(menu => {
            menu.classList.toggle("active", menu.dataset?.type === neededType);
        });

    }

// return to categories function
    function returnToCategory() {
        // remove active from all sub menus
        document.querySelectorAll(".sliderV3ContentItemLinks").forEach(menu => menu.classList.remove("active"));
    }

// guard - make sure we have valid menu items with children links
    if (menuCategories.length > 0) {
        menuCategories.forEach((category) => {
            category.addEventListener("click", function () {
                openItemMenu(category);
            })
        })
    }

// return to categories on sub menu title/arrow click
    document.querySelectorAll(".sliderV3ContentItemLinksTitle").forEach(button => {
        button.addEventListener("click", () => {
            returnToCategory();
        });
    });

    /**************
     Desktop Mega Menu
     ***************/

    /* Animation variables */
    let fadeIn = [{opacity: 0}, {opacity: 1}];
    let fadeTiming = {duration: 300, fill: 'forwards'};

    // desktop rail categories that have children carry a data-type; each maps to a detail pane
    const megaRailItems = document.querySelectorAll("#headerV3MegaRail .headerV3MegaRailItem[data-type]");
    const megaPanes = document.querySelectorAll("#headerV3MegaDetail .headerV3MegaDetailPane");

    function activateMegaPane(type) {
        // highlight the matching rail item and reveal its products pane
        megaRailItems.forEach(item => item.classList.toggle("active", item.dataset.type === type));
        megaPanes.forEach(pane => {
            if (pane.dataset.type === type) {
                // if it's already active, we don't need to toggle it again
                if (pane.classList.contains("active")) {
                    return;
                }
                pane.classList.add("active");
                pane.animate(fadeIn, fadeTiming);
            } else {
                pane.classList.remove("active");
            }
        });
    }

    // show the first category's products by default, then swap on hover
    if (megaRailItems.length > 0) {
        activateMegaPane(megaRailItems[0].dataset.type);
        megaRailItems.forEach(item => {
            item.addEventListener("mouseenter", function () {
                activateMegaPane(item.dataset.type);
            });
            // keyboard users: swap the pane when the rail item gains focus
            item.addEventListener("focus", function () {
                activateMegaPane(item.dataset.type);
            });
        });
    }
}());
